import request from '@/utils/seftRequest';

export function qryAvailableRelateOffer(params) {
  return request('/ding/subsService/qryAvailableRelateOfferBsnl', {
    method: 'POST',
    body: params,
  });
}

export function setVasBsnl(params) {
  return request('/ding/subsService/setVasBsnl', {
    method: 'POST',
    body: params,
  });
}
